import { render, staticRenderFns } from "./ExpensesListFilters.vue?vue&type=template&id=05faf720"
import script from "./ExpensesListFilters.vue?vue&type=script&lang=js"
export * from "./ExpensesListFilters.vue?vue&type=script&lang=js"
import style0 from "./ExpensesListFilters.vue?vue&type=style&index=0&id=05faf720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports